import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2>About Us</h2>
            <h3 style={{ marginTop: '15px', marginBottom: '15px', fontSize: '1.5em', color: '#2c3e50' }}>
              BSB Fortrade – Tech Driven Industrial Raw Material Distribution with an Integrated Supply Chain Platform
            </h3>
            <p className="lead" style={{ fontSize: '1.3em', color: '#2c3e50', marginBottom: '24px', fontWeight: 'bold'}}>
              Leading the way in Polymer Trading, Supply Chain & Logistics Excellence
            </p>
            <div className="about-timeline">
              <div className="timeline-item">
                <div className="timeline-year">2020 – Structural Expansion</div>
                <h4>Structural Expansion</h4>
                <p>
                  With a clear vision to build a professional and technology-backed trade platform: <strong>BSB Brokers LLP (India)</strong> was established and <strong>BSB Fortrade FZE (UAE)</strong> was incorporated. The objective was to create a Tech-Driven Distribution Model supported by an Integrated Supply Chain Platform, connecting suppliers, buyers, logistics partners, and finance institutions across borders.
                </p>
              </div>

              <div className="timeline-item">
                <div className="timeline-year">2024 – Technology Ownership & Scale</div>
                <h4>Technology Ownership & Scale</h4>
                <p>
                  In <strong>2024</strong>, the complete technology stack and digital infrastructure were launched under the brand BSB, with ownership under <strong>BSB Fortrade Pvt. Ltd.</strong> This marked the transition from traditional trading to a fully integrated, AI-enabled, and process-driven industrial raw material distribution ecosystem.
                </p>
              </div>
            </div>

            <div className="about-today-vision">
              <div className="timeline-item">
                <div className="timeline-year">Today</div>
                <h4>Today</h4>
                <p>
                  BSB operates as a Technology-Enabled Industrial Raw Material Distribution Platform, focused on: <strong>Prime & Recycled Polymer Distribution</strong>, <strong>Integrated Logistics & Supply Chain Solutions</strong>, and <strong>Global Sourcing & Trade Finance Integration</strong>.
                </p>
              </div>
              <div className="timeline-item">
                <div className="timeline-year">Vision</div>
                <h4>Vision</h4>
                <p style={{ fontStyle: 'italic' }}>
                  To build India's most trusted and technology-driven industrial raw material distribution ecosystem with global connectivity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;

